import { z } from 'zod';

export const CRM_CUSTOMER_TYPES = ['individual', 'company'] as const;
export const crmCustomerTypeEnum = z.enum(CRM_CUSTOMER_TYPES);
export type CrmCustomerType = z.infer<typeof crmCustomerTypeEnum>;

export const CRM_CUSTOMER_STATUSES = ['active', 'inactive', 'prospect'] as const;
export const crmCustomerStatusEnum = z.enum(CRM_CUSTOMER_STATUSES);
export type CrmCustomerStatus = z.infer<typeof crmCustomerStatusEnum>;

const addressSchema = z
  .object({
    street: z.string().trim().max(200).optional().or(z.literal('')),
    city: z.string().trim().max(100).optional().or(z.literal('')),
    state: z.string().trim().max(100).optional().or(z.literal('')),
    country: z.string().trim().max(100).optional().or(z.literal('')),
    pincode: z.string().trim().max(20).optional().or(z.literal('')),
  })
  .partial();

export const createCrmCustomerSchema = z.object({
  name: z.string().trim().min(2, 'Name must be at least 2 characters').max(160),
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email('Enter a valid email address')
    .optional()
    .or(z.literal('')),
  phone: z.string().trim().max(20).optional().or(z.literal('')),
  company: z.string().trim().max(160).optional().or(z.literal('')),
  position: z.string().trim().max(120).optional().or(z.literal('')),
  type: crmCustomerTypeEnum.default('company'),
  status: crmCustomerStatusEnum.default('active'),

  industry: z.string().trim().max(120).optional().or(z.literal('')),
  website: z.string().trim().max(200).optional().or(z.literal('')),
  gstin: z.string().trim().max(20).optional().or(z.literal('')),

  address: addressSchema.optional(),

  assignedTo: z.string().optional(),
  tags: z.array(z.string().trim().max(40)).default([]),
  notes: z.string().trim().max(2000).optional().or(z.literal('')),
});

export type CreateCrmCustomerInput = z.infer<typeof createCrmCustomerSchema>;

export const updateCrmCustomerSchema = createCrmCustomerSchema.partial();
export type UpdateCrmCustomerInput = z.infer<typeof updateCrmCustomerSchema>;

export const crmCustomerListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  status: crmCustomerStatusEnum.optional(),
  assignedTo: z.string().optional(),
  industry: z.string().trim().max(120).optional(),
  search: z.string().trim().max(200).optional(),
});

export type CrmCustomerListQuery = z.infer<typeof crmCustomerListQuerySchema>;
